import { Component } from '@angular/core';
import { CoreSignalEducation__CoreSignalEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Educations__CoreSignal') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignaleducation__coresignal-form',
    templateUrl: './coresignaleducation__coresignal.form.component.html'
})
export class CoreSignalEducation__CoreSignalFormComponent extends BaseFormComponent {
    public record!: CoreSignalEducation__CoreSignalEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

